// General
import React, { Component } from 'react';

// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';
import validate from './validate';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './AdminUserForm.css';
import bt from '../../../components/commonStyle.css';
import {
  Button,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import Link from '../../../components/Link';
import { createAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import { closeAdminUserModal } from '../../../actions/siteadmin/modalActions';

class AdminUserForm extends Component {

  static defaultProps = {
    roles: []
  };

  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl {...input} type={type} className={className} />
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
      </div>
    )
  }

  renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl as="select" {...input} className={className} >
          {children}
        </FormControl>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
      </div>
    )
  }

  async handleFormSubmit(values) {
    const { createAdminUser, paginationData } = this.props;
    const response = await createAdminUser(
      values.id,
      values.email,
      values.password,
      values.roleId
    );
    if (response && response.status === 200) {
      paginationData(1);
    }
  }

  render() {
    const { error, handleSubmit, submitting, id, roles, closeAdminUserModal } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx(s.formMaxWidth, 'maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <FormGroup className={cx('positionRelative', s.space5, s.spaceTop2)}>
            <label className={'inputLabel'}><FormattedMessage {...messages.emailLabel} /></label>
            <Field
              name="email"
              type="text"
              component={this.renderFormControl}
              label={formatMessage(messages.emailLabel)}
              className={s.formControlInput}
            // className={cx(bt.commonControlInput)}
            />
          </FormGroup>
          <FormGroup className={cx('positionRelative', s.space5)}>
            <label className={'inputLabel'}><FormattedMessage {...messages.password} /></label>
            <Field
              name="password"
              type="password"
              component={this.renderFormControl}
              label={formatMessage(messages.password)}
              className={s.formControlInput}
            // className={cx(bt.commonControlInput)}
            />
            <p className={cx(s.userText, s.spaceTop1)}><FormattedMessage {...messages.adminUserDesc} /></p>
          </FormGroup>
          <FormGroup className={'positionRelative'}>
            <label className={'inputLabel'}><FormattedMessage {...messages.roleLabel} /></label>
            <Field name="roleId" className={cx(s.formControlSelect, s.formControlInput)}
              component={this.renderFormControlSelect}
            >
              <option value={''}>{formatMessage(messages.selectroleLabel)}</option>
              {
                roles && roles.results && roles.results.length > 0 && roles.results.map((item, key) => {
                  return (
                    <option value={item.id} key={key}>{item.name}</option>
                  )
                })
              }
            </Field>
          </FormGroup>
          <FormGroup className={s.space1}>
            <div className={cx(bt.textAlignRight, 'modaltextAignRightRtl')}>
              <Link noLink onClick={() => closeAdminUserModal()} className={cx(s.backBtnTwo, s.btnSecondaryBorder, s.linkBtnInline, 'backBtnTwoRTL')} >{formatMessage(messages.goBack)}</Link>
              <Button type="submit" disabled={submitting} className={cx(s.button, s.btnPrimary)}>
                {id ? <FormattedMessage {...messages.update} /> : <FormattedMessage {...messages.addLabel} />}
              </Button>
            </div>
          </FormGroup>
        </form>
      </div>
    )
  }

}

AdminUserForm = reduxForm({
  form: "AdminUserForm", // a unique name for this form
  validate,
})(AdminUserForm);

const selector = formValueSelector('AdminUserForm');

const mapState = (state) => ({
  id: selector(state, 'id')
});

const mapDispatch = {
  createAdminUser,
  closeAdminUserModal
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AdminUserForm)));